import { ITaskDTO, IUserList } from '@g99-product-web-ui/shared-interface-lib';
import { MenuItem } from 'primeng/api';

export const SERVICE_STATUS_LIST = ['To Do', 'Completed', 'In Progress'];

export const SELECTED_DATE = 'selectedDates';

export const INPUT_BOX_VALUE = 'value';

export const getTAskListActionMenu = (
  data: ITaskDTO,
  deleteRow?: (data: ITaskDTO) => void,
  editRow?: (data: ITaskDTO) => void
): MenuItem[] => [
  {
    label: 'Edit',
    command: editRow ? () => editRow(data) : undefined, // Call editRow if available
  },
  {
    label: 'Delete',
    command: deleteRow ? () => deleteRow(data) : undefined, // Call deleteRow if available
  },
];

export const EDITOR_OPTIONS = {
  modules: {
    toolbar: [
      ['bold', 'italic', 'underline'], // Text styling options
      [{ list: 'ordered' }, { list: 'bullet' }], // List options
      ['link'], // Media options
      [{ color: [] }], // Text color and background
    ],
  },
  placeholder: 'Type something...', // Default placeholder
};

export enum TASK_STATUS {
  TODO = 'To Do',
  COMPLETED = 'Completed',
  IN_PROGRESS = 'In Progress',
}
export enum TASK_STATUS_FROM_API {
  TODO = 'Todo',
  IN_PROGRESS = 'Inprogress',
  COMPLETED = 'Completed',
}

export const PRIORITY_LIST = ['Medium', 'Low', 'High'];

export const ASSIGNEE_SEARCHABLE_FIELDS: Array<keyof IUserList> = [
  'firstName',
  'lastName',
  'fullName',
  'email',
];
